const FormElements = [
    {
        "flashname": "blog-flash",
        "inputs": [
            {
                "label": "blog Topic",
                "type": "input",
                "name":"topic",
                placeholder:"Eg: Uses cases of ai in graphic designing"
            },
            {
                "label": "Length",
                "type": "input",
                "name":"length",
                placeholder:"eg: 600-800 words"
            },
            {
                "label": "Keywords",
                "type": "input",
                "name":"keywords",
                placeholder:"eg: graphics, graphic designing, ai usecases in graphics "
            },
            {
                "label": "Tone",
                "type": "input",
                "name":"tone",
                placeholder:"Professional, Friendly, Witty,etc.."
            },

        ]

    },
    {
        flashname: "email-flash",
        inputs: [
            {
                label: "Email Topic",
                type: "input",
                name: "topic",
                placeholder:"Eg: Pay raise to manager"
            },
            {
                label: "Tone",
                type: "input",
                name: "tone",
                placeholder:"Professional, Friendly, Witty,etc.."
            },
        ]

    },
    {
        flashname: "blog-heading-flash",
        inputs: [
            {
                label: "Blog Topic",
                type: "input",
                name: "topic",
                placeholder:"Eg: Increasing website traffic"
            },
        ]

    },
    {
        flashname: "linkedin-post-flash",
        inputs: [
            {
                label: "Product or Service",
                type: "input",
                name: "topic",
                placeholder:"Eg: Flash Content AI is a smart AI based content generation product."
            },
            {
                label: "Tone",
                type: "input",
                name: "tone",
                placeholder:"Professional, Friendly, Witty,etc.."            },
        ]

    },
    {
        flashname: "youtube-script-flash",
        inputs: [
            {
                label: "Video Topic",
                type: "input",
                name: "topic",
                placeholder:"Eg: How to increase instagram followers"
            },
        ]

    },
    {
        flashname: "instagram-caption-flash",
        inputs: [
            {
                label: "Topic",
                type: "input",
                name: "topic",
                placeholder:"Eg: Uploading travel reel."
            },
        ]

    },
    {
        flashname: "blog-analyzer-flash",
        inputs: [
            {
                label: "Blog Post",
                type: "textarea",
                name: "topic",
                placeholder:"Eg: Copy and paste the blog post ..",
              
            },
        ]

    },
    {
        flashname: "ecommerce-faq-flash",
        inputs: [
            {
                label: "Website name and URL",
                type: "input",
                name: "topic",
                placeholder:"Eg: Flash Content AI, flashcontentai.com"
            },
        ]

    },
    {
        flashname: "meta-description-flash",
        inputs: [
            {
                label: "Website URL",
                type: "input",
                name: "topic",
                placeholder:"flashcontentai.com"
            },
        ]

    },
    {
        flashname: "help-page-flash",
        inputs: [
            {
                label: "Product",
                type: "input",
                name: "topic",
                placeholder:"Flash content ai is a one stop shop for content generation powered by AI"
            },
        ]

    },
    {
        flashname: "personalized-sales-flash",
        inputs: [
            {
                label: "Topic, Brand name, Offers, etc...",
                type: "input",
                name: "topic",
                placeholder:"Flash content ai is a one stop shop for content generation powered by AI"
            },
        ]

    },
    {
        flashname: "xml-sitemap-flash",
        inputs: [
            {
                label: "List of URLs ",
                type: "input",
                name: "topic",
                placeholder:"example.com, example2.com, subdomain.example.com"

            },
        ]

    },
    {
        flashname: "sales-pitch-flash",
        inputs: [
            {
                label: "Short Product Description with Key Features",
                type: "input",
                name: "topic",
                placeholder:"Flash content ai is a one stop shop for content generation powered by AI"

            },
        ]

    },
    {
        flashname: "paragraph-to-bulleted-list-flash",
        inputs: [
            {
                label: "Paragraph",
                type: "textarea",
                name: "topic",
                placeholder:"Do you really listen when you are talking with someone? I have a friend who listens in an unforgiving way. She actually takes every word you say as being something important and when you have a friend that listens like that, words take on a whole new meaning."

            },
        ]

    },
    {
        flashname: "advertising-campaign-strategy-flash",
        inputs: [
            {
                label: "Product Information",
                type: "input",
                name: "topic",
                placeholder:"Eg: Flash content ai is a one stop shop for content generation powered by AI"

            },
        ]

    },
    {
        flashname: "followup-email-to-lead-flash",
        inputs: [
            {
                label: "Product/Service Name with URL",
                type: "input",
                name: "topic",
                placeholder:"Eg: Flash Content AI, flashcontentai.com"

            },
        ]

    },
    {
        flashname: "keywords-flash",
        inputs: [
            {
                label: "Topic",
                type: "input",
                name: "topic",
                placeholder:"Eg: Use cases of ai in SEO"
            },
        ]

    },
    {
        flashname: "seo-brief-flash",
        inputs: [
            {
                label: "Blog Topic",
                type: "input",
                name: "topic",
                placeholder:"Blog Topic Eg: Use cases of ai in cybersecurity"
            },
        ]

    },
    {
        flashname: "referral-flash",
        inputs: [
            {
                label: "Product or Service",
                type: "input",
                name: "topic",
                placeholder:"Eg: Flash Content AI is a generative AI content creation product"
            },
        ]

    },
    {
        flashname: "blog-intro-flash",
        inputs: [
            {
                label: "Blog Topic",
                type: "input",
                name: "topic",
                placeholder:"Eg: Increase website speed"
            },
            {
                label: "keywords",
                type: "input",
                name: "keywords",
                placeholder:"Eg: Increase website speed, website speed, website traffic"
            },

        ]

    },
    {
        flashname: "product-keyword-flash",
        inputs: [
            {
                label: "Product or Service",
                type: "input",
                name: "topic",
                placeholder:"Eg: Flash Content AI is a generative AI content creation product"

            },
            

        ]

    },
    {
        flashname: "sales-landingpage-flash",
        inputs: [
            {
                label: "Product / Service to generate landing page description for:",
                type: "input",
                name: "topic",
                placeholder:"Eg: Flash Content AI is a generative AI content creation product"


            },
            

        ]

    },
    {
        flashname: "weekly-newsletter-flash",
        inputs: [
            {
                label: "Topic",
                type: "input",
                name: "topic",
                placeholder:"Eg: Flash Content AI is a generative AI content creation product"

            },
            

        ]

    },
    {
        flashname: "cold-email-flash",
        inputs: [
            {
                label: "Topic",
                type: "input",
                name: "topic",
                placeholder:"Eg: Flash Content AI is a generative AI content creation product"

            },
            {
                label: "Niche",
                type: "input",
                name: "niche",
                placeholder:"Eg: marketing business, startups, sales, etc.."

            },
            

        ]

    },
    {
        flashname: "resume-achievements-flash",
        inputs: [
            {
                label: "Topic",
                type: "input",
                name: "topic",
                placeholder:"Eg: My recent role was a sales professional at XYZ international"

            },
            

        ]

    },
    {
        flashname: "followup-email-with-subject",
        inputs: [
            {
                label: "Subject",
                type: "input",
                name: "topic",
                placeholder:"Eg: Increase Website Traffic by 100%"

            },
            

        ]

    },
    {
        flashname: "powerful-cta-flash",
        inputs: [
            {
                label: "Topic to create CTA for",
                type: "input",
                name: "topic",
                placeholder:"Eg: Product/Service brief"

            },
            

        ]

    },
    {
        flashname: "paragraph-rewriter-flash",
        inputs: [
            {
                label: "Paragraph",
                type: "textarea",
                name: "topic",
                placeholder:"Eg: Do you really listen when you are talking with someone? I have a friend who listens in an unforgiving way. She actually takes every word you say as being something important and when you have a friend that listens like that, words take on a whole new meaning."

            },
            {
                label: "Tone",
                type: "input",
                name: "tone",
                placeholder:"Professional, Friendly, Witty, etc.."

            },
            

        ]

    },
    {
        flashname: "paragraph-expander-flash",
        inputs: [
            {
                label: "Paragraph",
                type: "textarea",
                name: "topic",
                placeholder:"Eg: Do you really listen when you are talking with someone? I have a friend who listens in an unforgiving way. She actually takes every word you say as being something important and when you have a friend that listens like that, words take on a whole new meaning."


            },
            {
                label: "Tone",
                type: "input",
                name: "tone",
                placeholder:"Professional, Friendly, Witty, etc.."


            },
            

        ]

    }, {
        flashname: "sentence-expander-flash",
        inputs: [
            {
                label: "Sentence",
                type: "input",
                name: "topic",
                placeholder:"He appeared to be confusingly perplexed."
            },
            {
                label: "Tone",
                type: "input",
                name: "tone",
                placeholder:"Professional, Friendly, Witty, etc.."

            },
            

        ]

    },{
        flashname: "sentence-rewriter-flash",
        inputs: [
            {
                label: "Sentence",
                type: "input",
                name: "topic",
                placeholder:"He appeared to be confusingly perplexed."

            },
            {
                label: "Tone",
                type: "input",
                name: "tone",
                placeholder:"Professional, Friendly, Witty, etc.."

            },
            

        ]

    },
    {
        flashname: "sentence-generator-flash",
        inputs: [
            {
                label: "Topic",
                type: "input",
                name: "topic",
                placeholder:"Eg: How to start a SEO business"

            },
            {
                label: "Tone",
                type: "input",
                name: "tone",
                placeholder:"Professional, Friendly, Witty, etc.."

            },
            

        ]

    },
    {
        flashname: "paragraph-generator-flash",
        inputs: [
            {
                label: "Paragraph",
                type: "textarea",
                name: "topic",
                placeholder:"How to start a business"

            },
            {
                label: "Tone",
                type: "input",
                name: "tone",
                placeholder:"Professional, Friendly, Witty, etc.."

            },
            

        ]

    },
    {
        flashname: "blog-conclusion-flash",
        inputs: [
            {
                label: "Blog Title/Topic",
                type: "input",
                name: "topic",
                placeholder:"How to increase website traffic"

            },
            {
                label: "What is the blog about?",
                type: "input",
                name: "details",
                placeholder:"The blog is about increasing website traffic by 10x"

            },
            

        ]

    },
    {
        flashname: "landing-page-copy-flash",
        inputs: [
            {
                label: "What is your landing about?",
                type: "textarea",
                name: "topic",
                placeholder:"Product Flash, ai based content writer"

            },
            {
                label: "Tone",
                type: "input",
                name: "tone",
                placeholder:"Professional, Friendly, Witty, etc.."

            },
            

        ]

    },
    {
        flashname: "upwork-proposal-flash",
        inputs: [
            {
                label: "Project Description:(Copy and Paste)",
                type: "textarea",
                name: "topic",
                placeholder:"Copy the project description from upwork and paste"

            },
            {
                label: "Your freelancing details:(Name, Experience, etc..)",
                type: "textarea",
                name: "details",
                placeholder:"My name is John and i am a freelancer with 8+ years of experience in web development"

            },
            

        ]

    },
    



    {
        "flashname": "facebook-post-flash",
        "inputs": [{
            "label": "Post Topic",
            "type": "textarea",
            "name": "topic",
            placeholder:"Eg: Increase website traffic by 10x"

        }, {
            "name": "tone",
            "label": "Tone",
            "type": "input",
            placeholder:"Professional, Friendly, Witty, etc.."

        }, {
            "name": "target",
            "label": "Target Audience",
            "type": "input",
            placeholder:"Sales professional, marketing professional"
        }]
    }, {
        "flashname": "response-flash",
        "inputs": [{
            "label": "Message",
            "type": "textarea",
            "name": "topic",
            placeholder:"Hi Alex, how are we doing with the project?"
        }, {
            "name": "tone",
            "label": "Tone",
            "type": "input",
            placeholder:"Professional, Friendly, Witty, etc.."
        }, {
            "name": "details",
            "label": "What do you want to include in the message?",
            "type": "textarea",
            placeholder:"Yes, we are doing good with the project!"
        }]
    }, {
        "flashname": "email-response-flash",
        "inputs": [{
            "label": "Received Email",
            "type": "textarea",
            "name": "topic",
            placeholder:"Paste the email received"
        }, {
            "name": "tone",
            "label": "Tone",
            "type": "input",
            placeholder:"Professional, Friendly, Witty, etc.."
        }, {
            "name": "details",
            "label": "What do you want to include in the response?",
            "type": "textarea",
            placeholder:"Eg: Thanks we are doing well."
        }]
    }, {
        "flashname": "clickbaity-title-flash",
        "inputs": [{
            "label": "Topic",
            "type": "textarea",
            "name": "topic",
            placeholder:"Increase website traffic"
        }, {
            "name": "tone",
            "label": "Tone",
            "type": "input",
            placeholder:"Professional, Friendly, Witty, etc.."
        }]
    }, {
        "flashname": "content-summarizer-flash",
        "inputs": [{
            "label": "Content",
            "type": "textarea",
            "name": "topic",
            placeholder:"Eg: All he could think about was how it would all end. There was still a bit of uncertainty in the equation, but the basics were there for anyone to see. No matter how much he tried to see the positive, it wasn't anywhere to be seen. The end was coming and it wasn't going to be pretty."
        }]
    }, {
        "flashname": "grammar-corrector-flash",
        "inputs": [{
            "label": "Contect",
            "type": "textarea",
            "name": "topic",
            placeholder:"How is you doing?"
        }]
    }, {
        "flashname": "text-shortner-flash",
        "inputs": [{
            "label": "Text to shorten",
            "type": "textarea",
            "name": "topic",
            placeholder:"Eg: All he could think about was how it would all end. There was still a bit of uncertainty in the equation, but the basics were there for anyone to see. No matter how much he tried to see the positive, it wasn't anywhere to be seen. The end was coming and it wasn't going to be pretty."

        }]
    }, {
        "flashname": "event-generation-flash",
        "inputs": [{
            "label": "Event Name or Topic",
            "type": "input",
            "name": "topic",
            placeholder:"Ai conference"

        }, {
            "name": "details",
            "label": "Event Details",
            "type": "textarea",
            placeholder:"28th Jan 2024, 8am to 7pm IST, Banagalore, India"

        }, {
            "name": "tone",
            "label": "Tone",
            "type": "input",
            placeholder:"Professional, Friendly, Witty, etc.."

        }]
    }, {
        "flashname": "event-reminder-flash",
        "inputs": [{
            "label": "Existing Event Email",
            "type": "textarea",
            "name": "topic",
            placeholder:"Paste the exisitng event email"

        }, {
            "name": "tone",
            "label": "Tone",
            "type": "input",
            placeholder:"Professional, Friendly, Witty, etc.."

        }]
    }, {
        "flashname": "followup-email-flash",
        "inputs": [{
            "label": "Existing Email",
            "type": "textarea",
            "name": "topic",
            placeholder:"Paste the exisitng event email"

        }, {
            "name": "tone",
            "label": "Tone",
            "type": "input",
            placeholder:"Professional, Friendly, Witty, etc.."

        }]
    }, {
        "flashname": "email-subject-line-flash",
        "inputs": [{
            "label": "Email Topic",
            "type": "input",
            "name": "topic",
            placeholder:"Increase website traffic"

        }, {
            "name": "tone",
            "label": "Tone",
            "type": "input",
            placeholder:"Professional, Friendly, Witty, etc.."

        }]
    }, {
        "flashname": "resume-headlines-flash",
        "inputs": [{
            "label": "Job Role and Skills",
            "type": "textarea",
            "name": "topic",
            placeholder:"Web developer. Javscript development, backend development"

        }, {
            "name": "tone",
            "label": "Tone",
            "type": "input",
            placeholder:"Professional, Friendly, Witty, etc.."

        }]
    }, {
        "flashname": "linkedin-bio-flash",
        "inputs": [{
            "label": "Personal Information",
            "type": "textarea",
            "name": "topic",
            placeholder:"Web developer with 8+ years of experience"

        }]
    }, {
        "flashname": "linkedin-headline-flash",
        "inputs": [{
            "label": "Job Role  and skills",
            "type": "input",
            "name": "topic",
            placeholder:"Web developer. Javscript development, backend development"

        }, {
            "name": "tone",
            "label": "Tone",
            "type": "input",
            placeholder:"Professional, Friendly, Witty, etc.."

        }]
    }, {
        "flashname": "testimonial-flash",
        "inputs": [{
            "label": "Product/Service Name",
            "type": "input",
            "name": "topic",
            placeholder:"Product Flash, ai based content writer"
        }, {
            "name": "details",
            "label": "What do you want to include in the review/testimonial?",
            "type": "textarea",
            placeholder:"Flash is just a great product!"
        }, {
            "name": "tone",
            "label": "Tone",
            "type": "input",
            placeholder:"Professional, Friendly, Witty, etc.."
        }]
    }, {
        "flashname": "catchy-slogans-flash",
        "inputs": [{
            "label": "Product/Service/Business Information",
            "type": "textarea",
            "name": "topic",
            placeholder:"Product Flash, ai based content writer"
        }]
    }, {
        "flashname": "job-description-flash",
        "inputs": [{
            "label": "Job Title",
            "type": "input",
            "name": "topic",
            placeholder:"Web developer"
        }, {
            "name": "details",
            "label": "Skills",
            "type": "input",
            placeholder:"Javascript development, backend development"
        }]
    }, {
        "flashname": "job-title-flash",
        "inputs": [{
            "label": "Industry",
            "type": "input",
            "name": "topic",
            placeholder:"Software development"
        }, {
            "name": "details",
            "label": "Responsibilities",
            "type": "input",
            placeholder:"Web development, team management, etc.."
        }, {
            "name": "tone",
            "label": "Tone",
            "type": "input",
            placeholder:"Professional, Friendly, Witty, etc.."
        }]
    }, {
        "flashname": "interview-questions-flash",
        "inputs": [{
            "label": "Job Title",
            "type": "input",
            "name": "topic",
            placeholder:"Web developer"
        }]
    }, 
    
    {"flashname":"call-to-action-flash","inputs":[{"label":"Product/Service","type":"input","name":"topic","placeholder":"Eg: Flash ai based content writer.","wordlimit":"1000"},{"name":"details","label":"Main benefits of product/service","type":"textarea","placeholder":"Eg: Ai based content writing.","wordlimit":"3000"},{"name":"target","label":"What action do you want the user to take?","type":"input","placeholder":"Eg: signup to free account","wordlimit":"1000"}]}, 
 {"flashname":"business-name-flash","inputs":[{"label":"What is your business about?","type":"textarea","name":"topic","placeholder":"Eg: Flash is an ai based content writer","wordlimit":"1000"}]}, 
 {"flashname":"unique-value-proposition","inputs":[{"label":"Product Description","type":"textarea","name":"topic","placeholder":"Eg: Flash is an ai powered content generation product","wordlimit":"1000"},{"name":"tone","label":"Tone","type":"input","placeholder":"Professional, Friendly, Witty","wordlimit":""}]}, 
 {"flashname":"unique-selling-proposition","inputs":[{"label":"Product Description","type":"textarea","name":"topic","placeholder":"Eg: Flash is an ai based content generation product","wordlimit":"1000"},{"name":"tone","label":"Tone","type":"input","placeholder":"Professional, Friendly, Witty","wordlimit":""}]}, 
 {"flashname":"youtube-video-title","inputs":[{"label":"What is your video about?","type":"textarea","name":"topic","placeholder":"Eg: How to generate maximum leads.","wordlimit":"1000"},{"name":"tone","label":"Tone","type":"input","placeholder":"Professional, Friendly, Witty","wordlimit":""}]}, 
 {"flashname":"youtube-video-description","inputs":[{"label":"What is your video about?","type":"textarea","name":"topic","placeholder":"Eg: How to generate maximum leads","wordlimit":"1000"},{"name":"tone","label":"Tone","type":"input","placeholder":"Professional, Friendly, Witty","wordlimit":""}]}, 
 {"flashname":"live-course-curriculum","inputs":[{"label":"Course topic","type":"textarea","name":"topic","placeholder":"Cybersecurity High-level Training","wordlimit":"1000"},{"name":"target","label":"Course level","type":"input","placeholder":"beginner, Intermediate, Expert","wordlimit":""},{"name":"details","label":"Duration of the course","type":"input","placeholder":"75 min/day for 22 days","wordlimit":""}]}, 
 {"flashname":"product-description","inputs":[{"label":"Product Name & features","type":"textarea","name":"topic","placeholder":"Content Flash AI, AI Content generator","wordlimit":""}]}, 
 {"flashname":"linkedin-connection-note","inputs":[{"label":"Your Name:","type":"input","name":"topic","placeholder":"John Doe","wordlimit":""},{"name":"details","label":"Your short intro & connection intention","type":"textarea","placeholder":"I am a cybersecurity researcher and want to connect to Jay for gaining insights on latest industry trends","wordlimit":""}]}, 
 {
    "flashname": "whatsapp-post-flash",
    "inputs": [{
        "label": "Post Topic",
        "type": "textarea",
        "name": "topic",
        placeholder:"Share your thoughts, ideas, questions or product/service intro with links for promotion..."

    }, {
        "name": "tone",
        "label": "Tone",
        "type": "input",
        placeholder:"Friendly, Witty, etc.."

    }]
},
{"flashname":"valentine-message-flash","inputs":[{"label":"Name of the person you want to send to","type":"input","name":"topic","placeholder":"Anna","wordlimit":"100"},{"name":"details","label":"Any special message","type":"textarea","placeholder":"Eg: Our love forever","wordlimit":"200"},{"name":"tone","label":"Tone","type":"input","placeholder":"Eg: Romantic, Friendly, Funny","wordlimit":"50"}]}, 
{"flashname":"cold-email-subject-lines","inputs":[{"label":"Email Topic","type":"input","name":"topic","placeholder":"Eg: Marketing email for ai product named Content Flash AI","wordlimit":""},{"name":"tone","label":"Tone","type":"input","placeholder":"Professional, Friendly, Witty","wordlimit":""}]}, 
{"flashname":"blog-meta-description","inputs":[{"label":"Blog Title","type":"input","name":"topic","placeholder":"Use cases of AI in cybersecurity","wordlimit":"200"}]},  
//add

]
export default FormElements;